// extracted by mini-css-extract-plugin
export default {"listSpecialities":"style_listSpecialities__34aIQ"};